/*
 * premierstreets
 * version 4.5
* www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */


import { ProductOptionsDetailResponseModel } from './product-options-detail-response.model';

export class ProductDetailResponseModel {
    public Category: Array<any>;
    public dateAvailable: string;
    public description: string;
    public shortDescription: string;
    public location: string;
    public manufacturerId: string;
    public metaTagTitle: string;
    public minimumQuantity: string;
    public name: string;
    public price: string;
    public productId: string;
    public productImage: Array<any>;
    public productOriginalImage: Array<any>;
    public quantity: string;
    public shipping: string;
    public sku: string;
    public sortOrder: string;
    public stockStatusId: string;
    public subtractStock: string;
    public pricerefer: string;
    public flag: any;
    public upc: string;
    public productOption: ProductOptionsDetailResponseModel;
    public rating: number;
    public ratingCount: number;
    public reviewCount: number;
    public wishListStatus: number;
    public vendorId: number;
    public vendorName: string;
    public vendorCompanyName: string;
    public companyLogo: string;
    public companyLogoPath: string;
    public productSlug: string;
    public taxType: number;
    public taxValue: number;
    public buyed: number;
    public pincodeBasedDelivery: number;
    public hasStock: number;
    public minQuantityAllowedCart: number;
    public maxQuantityAllowedCart: number;
    public outOfStockThreshold: number;
    public enableBackOrders: number;
    public stockStatus: string;
    public hasTirePrice: number;
    public productTirePrices: Array<any>;
    public tirePrice: any;
    public vendorSlugName: any;
    public quotationAvailable: number;
    public discount: number;
    public weight: number;
    public vendorCompanyCity: any;
    public vendorCompanyState: any;
    public vendorPrefixId: string;

    public productVariant: any;
    public productVariantDetail: any;
    public productVariantList: any;
    public skuName: string;
    public skuId: number;
    public isSimplified: number;
    public selectedVariant: any;
    public variantName: string;
    public variantId: number;
    public isAvailable: boolean;
    public variantTirePrice: any;

    public productAttributes: any;
    public wishlistCount: number;
    public ratingPercentages: [];
    public vendorRating: number;
    public vendorWishlistCount: number;
    public ratingCounts: [];
    public vendorWishListStatus: number;
    public vendorWishListId: number;
    public vendor: any;
    public companyCoverImage: string;
    public chatStatus: number;
    public customerId: number;
    public productType: number;
    public contentType: number;
    public noOfOrders: number;
    public preview: string;
    public expirationDate: string;
    public expirationTime: string;
    public timezone: string;
    public length: number;
    public width: number;
    public height: number;
    public productGiftPrices: any;
    public bundleProducts: Array<any>

    public stokiest: number;

    public freezingProduct: number;
    public madeInBritain: number;
    public readyToCook: number;

    public companyCoverImagePath: string;
    public attributeList: Array<any>;
    public customizeProduct: number;
    constructor(listResponse: any) {
        this.freezingProduct = listResponse.freezingProduct || 0;
        this.madeInBritain = listResponse.madeInBritain || 0;
        this.readyToCook = listResponse.readyToCook || 0;

        this.description = listResponse.description || '';
        this.shortDescription = listResponse.shortDescription ? listResponse.shortDescription.replace(/<\/?[^>]+(>|$)/g, "") : ''
        this.Category = listResponse.Category || [];
        this.location = listResponse.location || '';
        this.dateAvailable = listResponse.dateAvailable || '';
        this.manufacturerId = listResponse.manufacturerId || '';
        this.metaTagTitle = listResponse.metaTagTitle || '';
        this.minimumQuantity = listResponse.minimumQuantity || '';
        this.name = listResponse.name || '';
        this.price = listResponse.price || '';
        this.productId = listResponse.productId || '';
        this.productImage = listResponse.productImage || [];
        this.productOriginalImage = listResponse.productOriginalImage || [];
        this.quantity = listResponse.quantity || '';
        this.shipping = listResponse.shipping || '';
        this.sku = listResponse.sku || '';
        this.sortOrder = listResponse.sortOrder || '';
        this.stockStatusId = listResponse.stockStatusId || '';
        this.subtractStock = listResponse.subtractStock || '';
        this.upc = listResponse.upc || '';
        this.chatStatus = listResponse.chatStatus || 0;
        this.customerId = listResponse.customerId || 0;
        if (listResponse.flag === 0) {
            this.flag = listResponse.flag;
        } else if (listResponse.flag === 1) {
            this.flag = listResponse.flag;
        } else {
            this.flag = listResponse.flag;
        }
        this.pricerefer = listResponse.pricerefer || '';
        this.productOption = listResponse.productOption || [];
        this.rating = listResponse.rating ? parseInt(listResponse.rating) : 0;
        this.wishListStatus = listResponse.wishListStatus || 0;
        this.vendorId = listResponse.vendorId || 0;
        this.vendorName = listResponse.vendorName || '';
        this.vendorCompanyName = listResponse.vendorCompanyName || '';
        this.companyLogo = listResponse.companyLogo || '';
        this.companyLogoPath = listResponse.companyLogoPath || '';
        this.productSlug = listResponse.productSlug || '';
        this.taxType = listResponse.taxType || 0;
        this.taxValue = Number(listResponse.taxValue) || 0;
        this.pincodeBasedDelivery = listResponse.pincodeBasedDelivery || 0;
        this.buyed = listResponse.buyed || 0;
        this.hasStock = listResponse.hasStock;
        this.minQuantityAllowedCart = listResponse.minQuantityAllowedCart;
        this.maxQuantityAllowedCart = listResponse.maxQuantityAllowedCart;
        this.outOfStockThreshold = listResponse.outOfStockThreshold;
        this.enableBackOrders = listResponse.enableBackOrders;
        this.stockStatus = listResponse.stockStatus || '';
        this.hasTirePrice = listResponse.hasTirePrice;
        this.productTirePrices = listResponse.productTirePrices || [];
        this.tirePrice = listResponse.tirePrice || '';
        this.vendorSlugName = listResponse.vendorSlugName || '';
        this.quotationAvailable = listResponse.quotationAvailable || 0;
        this.discount = listResponse.discount || 0;
        this.vendorCompanyCity = listResponse.vendorCompanyCity || '';
        this.vendorCompanyState = listResponse.vendorCompanyState || '';
        this.vendorPrefixId = listResponse.vendorPrefixId || '';
        this.productVariant = listResponse.productVarient || [];
        this.productGiftPrices = listResponse.productGiftPrices || [];
        this.productVariantDetail = listResponse.productVarientOption || [];
        this.skuId = listResponse.skuId || 0;
        this.skuName = listResponse.skuName || '';
        this.isSimplified = listResponse.isSimplified || 0;
        this.productVariantList = listResponse.productvarientList || [];
        this.selectedVariant = listResponse.selectedVariant || [];
        this.variantName = listResponse.variantName || '';
        this.variantId = listResponse.variantId || 0;
        this.isAvailable = listResponse.isAvailable;
        this.variantTirePrice = listResponse.variantTirePrice || [];
        this.ratingCount = listResponse.ratingCount || 0;
        this.reviewCount = listResponse.reviewCount || 0;
        this.productAttributes = listResponse.productAttributes || [];
        this.weight = listResponse.weight ? listResponse.weight : 0
        this.wishlistCount = listResponse.wishlistCount ? listResponse.wishlistCount : 0;
        this.ratingPercentages = listResponse.ratingPercentages ? listResponse.ratingPercentages : [];
        this.vendorRating = listResponse.vendorRating ? parseInt(listResponse.vendorRating) : 0;
        this.vendorWishlistCount = listResponse.vendorWishlistCount ? listResponse.vendorWishlistCount : 0;
        this.ratingCounts = listResponse.ratingCounts ? listResponse.ratingCounts : [];
        this.vendorWishListStatus = listResponse.vendorWishListStatus ? listResponse.vendorWishListStatus : 0;
        this.vendorWishListId = listResponse.vendorWishListId || 0;
        this.vendor = listResponse.vendor || null;
        this.companyCoverImagePath = listResponse.companyCoverImagePath || '';
        this.companyCoverImage = listResponse.companyCoverImage || '';
        this.productType = listResponse.productType || 0;
        this.contentType = listResponse.contentType || 0;
        this.preview = listResponse.preview || '';
        this.noOfOrders = listResponse.noOfOrders || 0;
        this.expirationDate = listResponse.expirationDate || '';
        this.expirationTime = listResponse.expirationTime || '';
        this.timezone = listResponse.timezone || '';
        this.length = listResponse.length || '';
        this.width = listResponse.width || '';
        this.height = listResponse.height || '';
        this.attributeList = listResponse.attributeList || [];
        this.customizeProduct = listResponse.isCustomizedProduct || 0;
        this.bundleProducts = listResponse.bundleProducts || [];
        this.stokiest = listResponse.stokiest;
    }
}
